var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfViewPart", {
    ref: "viewPart",
    staticClass: "dsf-form-pick-up",
    attrs: { showModel: _vm.showModel, path: _vm.path },
    on: { ready: _vm.init },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }